import { GetterTreeWithRootState } from '~/store/types'
import { I18nLocale } from '~/models/shared/types'
import { I18nState } from './state'
import VueRouter, { RawLocation } from 'vue-router'

export default {
  localeIsActive: state => (locale: I18nLocale) => locale === state.locale,
  locale: state => {
    return state.locale
  },
  // work in progress:
  getAvailableLocales: (_state, _getters, rootState) => (router: VueRouter) => {
    if (!router) {
      return []
    }
    const supportedLocales = [
      {
        locale: I18nLocale.EL,
        title: 'Ελληνικά',
        icon: require('~/assets/img/flags/el.png')
      },
      {
        locale: I18nLocale.EN,
        title: 'English',
        icon: require('~/assets/img/flags/en.png')
      }
    ]

    const selectedRoute =
      (rootState.classifieds.search &&
        rootState.classifieds.search.currentRoute) ||
      router.currentRoute

    return supportedLocales.map(sl => {
      return {
        locale: sl.locale,
        title: sl.title,
        icon: sl.icon,
        link: router.resolve({
          ...selectedRoute,
          query: { ...selectedRoute.query, lang: sl.locale }
        } as RawLocation).href
      }
    })
  }
} as GetterTreeWithRootState<I18nState>
